import React from 'react';
import './App.css';

function App() {
  const siteName = 'www True Religion Jeans';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
